/* eslint-disable */
import React, { useEffect, useState } from 'react'
import { ENTITYNAME } from '../../framework/constant/constant';
import { Grid, GridColumn } from '@progress/kendo-react-grid';
import { useTranslation } from '../../locale/useTranslation';
import AddRoundButton from '../../framework/forms/helpercomponents/buttons/AddRoundButton';
import DeleteRoundButton from '../../framework/forms/helpercomponents/buttons/DeleteRoundButton';
import { ConfirmDeleteAlert } from '../../ConfirmAlert';
import { utility } from '../../framework/utility/utilityProvider';
import CollectionSelection from '../../framework/forms/CollectionSelection';
import MyStatusCell from '../../components/MyStatusCell';
import { ImageCell } from '../../framework/forms/helpercomponents/CustomGridCells/ImageCell';
import { arrayEnumCell } from '../../framework/forms/helpercomponents/CustomGridCells/PlatformCell';

export const PaymentsEditForm = (props) => {

  const { data = [], setPaymentsData } = props;
  console.log(data);

  const lang = useTranslation();
  const [showPaymentPlan, setShowPaymentPlan] = useState(false);

  const handlePaymentPlanData = (dataList) => {
    let finalData = utility.checkDuplicateInData(dataList, data, "Description");
    setPaymentsData([...data, ...finalData]);
  }

  const deleteData = (dataItem) => {
    let newData = data.filter(item => item._id !== dataItem._id);
    setPaymentsData(newData);
  }

  const Mystatuscell = (props) => {
    let tileBackColor = props.dataItem?.isActive ? "#63aa43" : "#E72929";
    return <MyStatusCell title={props.dataItem?.isActive ? "Active" : "Deactive"} tileBackColor={tileBackColor} />
  }

  const MyCommandCell = (props) => (
    <div className="mt-3 ml-4" style={{ display: "flex" }}>
      <DeleteRoundButton onClick={() => ConfirmDeleteAlert(() => deleteData(props.dataItem), () => { })} />
    </div>
  )

  const deleteAllData = () => {
    setPaymentsData([]);
  }

  return (
    <>
      <AddRoundButton onClick={() => setShowPaymentPlan(true)} style={{ marginLeft: "-15px" }} title={lang.add_provider_button_tooltip} />
      {data.length > 0 && <DeleteRoundButton style={{ marginLeft: "10px" }} title={lang.delete_all_button_tooltip} onClick={() => ConfirmAlert(() => deleteAllData(), () => { }, lang.confirm_delete_all_label, lang.are_you_sure_do_you_want_to_delete_all_label)} />}

      <Grid data={data} style={{ height: "35vh", margin: "5px -15px 0px -15px" }} resizable>
        <GridColumn cell={MyCommandCell} width={"80px"} locked={true} />
        <GridColumn field="brandingLogo" title={lang.branding_logo_column} cell={ImageCell} width={120} />
        <GridColumn field="Name" title={lang.name_column} width={250}/>
        <GridColumn field="isActive" title={lang.status_column} cell={Mystatuscell} width={150} />
        <GridColumn field="OS" title={lang.os_column} cell={arrayEnumCell} />
      </Grid>

      {showPaymentPlan && <CollectionSelection title={lang.select_payment_plan_collection} setDataList={handlePaymentPlanData} entityname={ENTITYNAME.PaymentProvider} closeForm={() => setShowPaymentPlan(false)} mode={'multiple'} width={"50vw"} />}
    </>
  )
}
